export const SOLD_NON_DISCLOSURE_STATES = new Set([
  'AK', 'ID', 'KS', 'LA', 'MS', 'MT', 'NM', 'TX', 'UT', 'WY',
]);

export function isNonDisclosureState(stateAbbreviation) {
  return SOLD_NON_DISCLOSURE_STATES.has(String(stateAbbreviation || '').trim().toUpperCase());
}
